import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { dashboardBoxList, dashboardList, eventBoxList, userEventRecordHistoryList, userEventTaskList } from "../../services/api";
import { secretKey } from "../../services/config";
import EncryptDecrypt from "../../utils/encrypt&decrypt";
import { act } from "react";
import alertmessage from "../../utils/alert";
const namespace = "dashboard";

export const getDashboardList = createAsyncThunk(
    `${namespace}/getDashboardList`,
    async (
        { _, rejectWithValue }
    ) => {
        try {
            const data = await dashboardList();
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const getDashboardPreprcoessBox = createAsyncThunk(
    `${namespace}/getDashboardPreprcoessBox`,
    async ({ id }, { rejectWithValue }) => {
        try {
            const data = await dashboardBoxList({ id });
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getEventBoxCount = createAsyncThunk(
    `${namespace}/getEventBoxCount`,
    async ({ _, rejectWithValue }) => {
        try {
            const data = await eventBoxList();
            return JSON.parse(EncryptDecrypt.decryptdata(data?.data?.datas, secretKey));
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);

export const getUserEventTaskList = createAsyncThunk(
    `${namespace}/getUserEventTaskList`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", id }, { rejectWithValue }) => {
        try {
            const data = await userEventTaskList({ query, page, limit, sortby, order, id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
export const getUserEventRecordHistoryList = createAsyncThunk(
    `${namespace}/getUserEventRecordHistoryList`,
    async ({ query = "", page = 0, limit = 0, sortby = "", order = "", id, user_id }, { rejectWithValue }) => {
        try {
            const data = await userEventRecordHistoryList({ query, page, limit, sortby, order, id, user_id });
            return JSON.parse(
                EncryptDecrypt.decryptdata(data?.data?.datas, secretKey)
            );
        } catch (error) {
            return rejectWithValue(error.response);
        }
    }
);
const dashboardSlice = createSlice({
    name: namespace,
    initialState: {
        dashboardLoading: false,
        dashboardListData: [],
        dashboardListDataError: false,
        dashboardPreprocessData: [],
        getEventBoxCountData: [],
        dashboardPreprocessDataError: false,
        getUserEventTaskListData: [],
        getUserEventRecordHistoryListData: []


    },
    reducers: {
        resetSuccessFlag: (state, action) => {
            const { flag } = action.payload;
            state[flag] = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardList.pending, (state) => {
                state.dashboardLoading = true;
                state.dashboardListDataError = false;
            })
            .addCase(getDashboardList.fulfilled, (state, action) => {
                state.dashboardListData = action.payload;
                state.dashboardLoading = false;
            })
            .addCase(getDashboardList.rejected, (state, action) => {
                state.dashboardListDataError = true;
                state.dashboardLoading = false;
                if (action?.payload?.data?.auth === "deleted") {
                    alertmessage.sweetalert(action?.payload?.data?.message);
                }
            }).addCase(getDashboardPreprcoessBox.pending, (state) => {
                state.dashboardLoading = true;
            })
            .addCase(getDashboardPreprcoessBox.fulfilled, ((state, action) => {
                state.dashboardPreprocessData = action.payload
                state.dashboardLoading = false


            }))
            .addCase(getDashboardPreprcoessBox.rejected, ((action, state) => {
                state.dashboardLoading = false
                state.dashboardPreprocessDataError = action.payload
            }))
            .addCase(getEventBoxCount.pending, ((state, action) => {
                state.dashboardLoading = true
            }))
            .addCase(getEventBoxCount.fulfilled, ((state, action) => {
                state.getEventBoxCountData = action.payload
                state.dashboardLoading = false
            }))
            .addCase(getEventBoxCount.rejected, ((state, action) => {
                state.dashboardLoading = false
            }))
            .addCase(getUserEventTaskList.pending, (state) => {
                state.dashboardLoading = true;
            })
            .addCase(getUserEventTaskList.fulfilled, (state, action) => {
                state.dashboardLoading = false;
                state.getUserEventTaskListData = action.payload;
            })
            .addCase(getUserEventTaskList.rejected, (state) => {
                state.dashboardLoading = false;
            })
            .addCase(getUserEventRecordHistoryList.pending, (state) => {
                state.dashboardLoading = true;
            })
            .addCase(getUserEventRecordHistoryList.fulfilled, (state, action) => {
                state.dashboardLoading = false;
                state.getUserEventRecordHistoryListData = action.payload;
            })
            .addCase(getUserEventRecordHistoryList.rejected, (state) => {
                state.dashboardLoading = false;
            })



    }
})

export const { resetSuccessFlag } = dashboardSlice.actions;
export const dashboardSelector = (state) => state[namespace];
export default dashboardSlice.reducer;